import Month from '../models/months';
import MonthlyOffer from '../models/monthly-offer';

const offersCollection: MonthlyOffer[] = [
  // ##### TEMPLATE
  // {
  //   month: Month.XX,
  //   year: 2024,
  //   offers: [
  //     {
  //       title: '',
  //       description: '',
  //       imgFile: '.png',
  //       offerPrice: 0.0,
  //     },
  //     {
  //       title: '',
  //       description: '',
  //       imgFile: '.png',
  //       offerPrice: 0.0,
  //     },
  //     {
  //       title: '',
  //       description: '',
  //       imgFile: '.png',
  //       offerPrice: 0.0,
  //     },
  //   ],
  // },
  // #####
  {
    month: Month.March,
    year: 2024,
    offers: [
      {
        title: 'Allegra',
        description: 'Antiallergikum, 50 Tabletten',
        imgFile: 'allegra_allergietabletten_50st.png',
        offerPrice: 22.99,
      },
      {
        title: 'Diclo-ratiopharm',
        description: 'bei Fieber & Schmerzen, 20 Tabletten',
        imgFile: 'diclo_rationpharm_filmtabletten_25mg.png',
        offerPrice: 5.99,
      },
      {
        title: 'Cetirizin',
        description: 'Antiallergikum, 20 Filmtabletten',
        imgFile: 'cetirizin_antiallergikum_20filmtabletten.png',
        offerPrice: 5.99,
      },
    ],
  },
  {
    month: Month.April,
    year: 2024,
    offers: [
      {
        title: 'Gaviscon Dual',
        description: 'bei Sodbrennen, 12 Beutel',
        imgFile: 'gaviscon_dual_12b.png',
        offerPrice: 9.99,
      },
      {
        title: 'LoranoPro',
        description: 'Antiallergikum, 18 Filmtabletten',
        imgFile: 'lorano-pro-18filmtabletten.png',
        offerPrice: 8.99,
      },
      {
        title: 'MometaHexal',
        description: 'Allergienasenspray, 60 Sprühstöße',
        imgFile: 'mometahexal-nasenspray.png',
        offerPrice: 9.99,
      },
    ],
  },
];

export default offersCollection;
